/**
 * RTWO Indexer Engine — Service Registry
 */

import type { IIndexerService } from '../service-interfaces';

export class IndexerServiceRegistry {
  private readonly services = new Map<string, IIndexerService>();

  register(service: IIndexerService): void {
    this.services.set(service.serviceId, service);
  }

  get<T extends IIndexerService>(serviceId: string): T | null {
    return (this.services.get(serviceId) as T) ?? null;
  }

  getAll(): IIndexerService[] {
    return Array.from(this.services.values());
  }

  has(serviceId: string): boolean {
    return this.services.has(serviceId);
  }

  count(): number {
    return this.services.size;
  }
}
